/** sessionData.contents에서 stepCode별 파일 목록 (contentOrder 오름차순) */
export const getStepContents = (contents, stepCode) =>
  (contents ?? [])
    .filter((c) => c.stepCode === stepCode)
    .sort((a, b) => Number(a.contentOrder) - Number(b.contentOrder));

export const buildDocumentFileUrl = (path, baseUrl) => {
  if (!path) return '';
  const ext = path.split('.').pop()?.toLowerCase();
  let finalPath = path;
  if (['hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
    finalPath = path.replace(/\.[^/.]+$/, '.pdf');
  }
  return `${baseUrl}files/${finalPath}`;
};
